<template>
    <vue-nav-bar></vue-nav-bar>

    <div class="py-4">
        <!-- Hero Section -->
        <div class="heroContainer">
            <section id="hero" class="hero section dark-background">
                <div class="container d-flex flex-column align-items-center">
                    <h2>{{ $Translate('heroTitle') }}</h2>
                    <p>{{ $Translate('heroSubTitle') }}</p>

                    <div class="radio-group">
                        <label v-for="option in options" :key="option.value" class="radio-option"
                            :class="{ 'selected': selectedDept === option.value }" @click="onAllSelect">
                            <input type="radio" :checked="selectedDept === option.value" class="hidden" />
                            <span>{{ option.label }}</span>
                        </label>
                        <label v-for="dept in departmentsList" :key="dept.recId" class="radio-option"
                            :class="{ 'selected': selectedDept === dept.departmentName }"
                            @click="onDepartmentSelect(dept)">
                            <input type="radio" :checked="selectedDept === dept.departmentName" class="hidden" />
                            <span>{{ dept.departmentName }}</span>
                        </label>
                    </div>
                </div>
            </section>
        </div>

        <div class="input-group mb-3">
            <span class="input-group-text">{{ $Translate('filterByCity') }}</span>
            <div class="form-floating">
                <select class="form-control" aria-label="Select City" aria-describedby="cityFilter" v-model="city"
                    @change="onCitySelect(item)">
                    <option value="" selected>{{ $Translate('selectCity') }}</option>
                    <option v-for="(item, index) in [...new Set(citiesList.filter(c => c !== ''))]" :key="index"
                        :value="item">
                        {{ item }}</option>
                </select>
                <label for="citySelect" class="form-label">{{ $Translate('chooseCity') }}</label>
            </div>
        </div>

        <div class="container mt-5 mb-3" v-for="job in jobsList">
            <div class="row">
                <div class="card-container col-md-12 shadow-sm">
                    <div class="card p-3 mb-2">
                        <div class="d-flex justify-content-between">
                            <!-- Logo -->
                            <div class="d-flex flex-row align-items-center">
                                <div class="lable text-center pt-2 pb-2">
                                    <ul class="list-unstyled text-white mb-0 text-uppercase">
                                        <li class="list-inline-item"><i class="fa fa-briefcase"></i></li>
                                    </ul>
                                </div>
                                <div class="ms-2 c-details">
                                    <img src="../../../../dist/assets/GITS.png"
                                        style="width: auto; height: 90px; margin-top: 15px;">
                                </div>
                            </div>
                            <!-- Dept. Badge -->
                            <div class="badge"> <span>{{ job.department }}</span> </div>
                        </div>
                        <div class="mt-5">
                            <!-- Job Position -->
                            <div>
                                <h3>{{ job.job }}</h3> <!-- Job -->
                                <span class="text-muted fs-5 d-block">{{ job.description }}</span> <!-- Description -->
                            </div>

                            <!-- Job Description -->
                            <p class="job-description mt-4" style="max-height: 150px; overflow-y: auto;"
                                v-html="job.jobAdds"></p>

                            <!-- Card Footer -->
                            <div class="card-footer mt-1 d-flex justify-content-between align-items-center">
                                <div class="d-flex">
                                    <div class="me-3">
                                        <strong>{{ $Translate('startDateLabel') }}:</strong> <span>{{
                                            $ConvertToDateFormat(job.startDate)
                                        }}</span>
                                        <!-- startDate -->
                                    </div>
                                    <div class="me-3">
                                        <strong>{{ $Translate('finalDateLabel') }}:</strong> <span>{{
                                            $ConvertToDateFormat(job.finalDate)
                                        }}</span>
                                        <!-- finalDate -->
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <RouterLink class="btn btn-outline-primary me-2"
                                        :to="{ path: '/JobDetails', query: { jobId: job.recId } }">
                                        <i class="fas fa-info-circle me-2"></i> {{ $Translate('details') }}
                                    </RouterLink>
                                    <button class="btn btn-primary" type="button" @click="checkToken(job.recId)">
                                        <i class="fas fa-paper-plane me-2"></i> {{ $Translate('applyNow') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- Warning Pop-Up (Login) -->
    <div class="modal fade" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-delete-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="warning-icon mb-4">
                        <img :src="warningGif" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('loginMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('loginWarningMessageBody') }}</p>

                    <div class="d-flex justify-content-center gap-3">
                        <button class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            @click="goTo('/Login')">
                            {{ $Translate('login') }}
                        </button>
                        <button class="btn btn-outline-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            @click="goTo('/Registration')">
                            {{ $Translate('register') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Apply Confirmation Modal -->
    <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-delete-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="warning-icon mb-4">
                        <img :src="warningGif" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('applyAlert') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('applyWarningMessageTitle') }}</p>

                    <div class="d-flex justify-content-center gap-3">
                        <button type="button" class="btn btn-light px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('cancel') }}
                        </button>
                        <button type="button" class="btn btn-primary px-4 py-2 rounded-3" @click="confirmApply()">
                            {{ $Translate('apply') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Attachment Warning Pop-Up (Apply) -->
    <div class="modal fade" id="attachmentWarningModal" tabindex="-1" aria-labelledby="attachmentWarningModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content custom-delete-modal text-center px-4 py-3 rounded-4">

                <div class="modal-header border-0 p-0">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div class="warning-icon mb-4">
                        <img :src="warningGif" alt="Animated GIF" class="img-fluid" />
                    </div>
                    <h4 class="fw-bold mb-2">{{ $Translate('attachmentWarningMessageTitle') }}</h4>
                    <p class="text-muted mb-4">{{ $Translate('attachmentWarningMessageBody') }}</p>

                    <div class="d-flex justify-content-center gap-3">
                        <button class="btn btn-outline-primary px-4 py-2 rounded-3" data-bs-dismiss="modal">
                            {{ $Translate('cancel') }}
                        </button>
                        <button class="btn btn-primary px-4 py-2 rounded-3" data-bs-dismiss="modal"
                            @click="goToResumeTab()">
                            {{ $Translate('yes') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <vue-footer :project_name="'Applicant Portal.'"></vue-footer>
</template>

<script>
let loginModal = null;
let applyModal = null;
let attachmentWarningModal = null;

import { RouterLink } from 'vue-router';
import { Modal } from 'bootstrap';
import { runWithoutBlocking } from '../../VueGlobal';

export default {
    name: 'HomePage',
    data() {
        return {
            selectedDept: "all",
            options: [
                { value: "all", label: "All" }
            ],
            companyId: 'usmf',
            token: GetToken(),
            applicantId: GetApplicantId(),
            departmentsList: [],
            citiesList: [],
            jobsList: [],
            departmentId: 0,
            city: "",

            warningGif: require('../../../assets/animations/warning.gif'),

            jobToApplyRecId: null,
            ApplicantAttachment: [],
        };
    },
    methods: {
        /*
        GetCityList: async function () {
            try {
                this.citiesList = await GetCityList();
            } catch (error) {
                console.error("Error fetching cities:", error);
            }
        },
        */
        GetDepartmentList: async function () {
            try {
                this.departmentsList = await GetDepartmentList(this.companyId);
            } catch (error) {
                console.error("Error fetching Dept.:", error);
            }
        },
        GetJobList: async function () {
            try {
                this.jobsList = await GetJobList(this.companyId, this.departmentId, this.city);

                this.citiesList = this.jobsList.map(c => c.city);
            } catch (error) {
                console.error("Error fetching Jobs:", error);
            }
        },
        GetApplicantAttachment: async function () {
            try {
                this.ApplicantAttachment = await GetApplicantAttachment(
                    this.companyId,
                    this.applicantId,
                );
            } catch (error) {
                console.error("Validation failed:", error);
            }
        },
        onDepartmentSelect(dept) {
            if (this.selectedDept === dept.departmentName) return;
            this.selectedDept = dept.departmentName;
            this.departmentId = dept.recId;
            this.GetJobList();
        },
        onAllSelect() {
            if (this.selectedDept === 'all') return;
            this.selectedDept = 'all';
            this.departmentId = 0;
            this.GetJobList();
        },
        onCitySelect() {
            if (!this.city) {
                this.city = ""
            }
            this.GetJobList();
        },
        goTo(path) {
            this.$router.push(path)
        },
        async checkToken(recId) {
            if (!GetToken()) {
                loginModal.show();
                return;
            }

            if (this.ApplicantAttachment.length <= 0) {
                await this.GetApplicantAttachment();
            }

            if (this.ApplicantAttachment.length <= 0) {
                attachmentWarningModal.show();
            } else {
                applyModal.show();
                this.jobToApplyRecId = recId;
            }
        }
        ,
        async apply(recId) {
            try {
                const response = await ApplyForJob(this.companyId, this.applicantId, recId);

                if (response && response.status === 200) {
                    toastr.success(this.$Translate('jobAppliedSuccessfully'));

                    this.GetApplicantApplication();
                } else {
                    toastr.error(this.$Translate('errorApplying'));
                }
            } catch (error) {
                console.error("Error applying applicant application:", error);
            }
        },
        GetApplicantApplication: async function () {
            try {
                this.ApplicantApplication = await GetApplicantApplication(
                    this.companyId,
                    this.applicantId,
                );
            } catch (error) {
                console.error("Validation failed:", error);
            }
        },
        async confirmApply() {
            await this.apply(this.jobToApplyRecId);
            this.jobToApplyRecId = null;

            applyModal.hide();
        },
        goToResumeTab() {
            this.$router.push({ path: '/ApplicantProfile', query: { tab: 'resumeTab' } });
        }
    },
    async mounted() {
        BlockPage();
        await runWithoutBlocking(async () => {
            await Promise.all([this.GetDepartmentList(), this.GetJobList()]);
        });
        UnBlockPage();

        loginModal = new Modal(document.getElementById("loginModal"), {});
        applyModal = new Modal(document.getElementById("applyModal"), {});
        attachmentWarningModal = new Modal(document.getElementById("attachmentWarningModal"), {});
    }
};
</script>

<style scoped>
.heroContainer {
    position: relative;
    background-image: url('../../../../dist/assets/hero3-bg.jpg');
    background-size: cover;
    background-position: center;
    padding-top: 130px;
    padding-bottom: 130px;
    color: white;
    text-align: center;
    overflow: hidden;
    height: 55vh;
    margin-top: -23px;
    border-radius: 0 0 45% 45%;
}

.heroContainer::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1;
}

.heroContainer .container {
    position: relative;
    z-index: 2;
}

.heroContainer h2,
.heroContainer p {
    text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.heroContainer .btn-get-started,
.heroContainer .btn-watch-video {
    padding: 12px 30px;
    border-radius: 25px;
    background-color: #FC7F3F;
    color: white;
    text-transform: uppercase;
    font-weight: bold;
    margin: 5px;
    transition: all 0.3s ease;
}

.heroContainer .btn-get-started:hover,
.heroContainer .btn-watch-video:hover {
    background-color: #e66e32;
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.radio-group {
    display: flex;
    border: 2px solid #2B2D42;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 50px;
}

.radio-option {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 80px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    background-color: #E8E9EB;
    color: #00013A;
    border-right: 2px solid #2B2D42;
}

.radio-option:hover {
    background-color: #FFD1A4;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

.radio-option:last-child {
    border-right: none;
}

.radio-option.selected {
    background-color: #00013A;
    color: white;
}

.hidden {
    display: none;
}

@media (max-width: 768px) {
    .radio-group {
        flex-direction: column;
        margin-bottom: 30px;
    }

    .radio-option {
        border-right: none;
        border-bottom: 2px solid #2B2D42;
    }

    .radio-option:last-child {
        border-bottom: none;
    }
}

.input-group {
    display: flex;
    justify-content: center;
    width: 70%;
    margin: 20px auto 0;
}

.form-control {
    border-radius: 0.375rem;
    /* Rounded corners */
    border-color: #ccc;
    transition: border-color 0.3s;
}

.form-control:focus {
    border-color: #00013A;
    /* Highlight color on focus */
}

.input-group-text {
    background-color: #00013A;
    color: white;
    font-weight: bold;
}

.card {
    border: none;
    border-radius: 10px
}

.c-details span {
    font-weight: 300;
    font-size: 13px
}

.icon {
    width: 50px;
    height: 50px;
    background-color: #eee;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 39px
}

.badge span {
    background-color: #FC7F3F;
    width: 110px;
    height: 35px;
    padding-bottom: 3px;
    border-radius: 5px;
    display: flex;
    color: white;
    justify-content: center;
    align-items: center;
    font-size: 13px;
}

.progress {
    height: 10px;
    border-radius: 10px
}

.progress div {
    background-color: red
}

.text1 {
    font-size: 14px;
    font-weight: 600
}

.text2 {
    color: #a5aec0
}

.card-container {
    border: 1px solid #eee;
    border-radius: 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease, transform-origin 0.3s ease;
}

.card-container:hover {
    transform: translateY(-15px) scale(1.02);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
    transform-origin: center center;
}

.card-footer {
    background-color: #E8E9EB;
    margin: -28px;
    height: 70px;
}
</style>
